import { Badge } from '@apps/web/components/ui/badge';
import {
    getRoleColor,
    getRoleDisplayName,
    getRoleFullName,
} from '@apps/web/lib/caregiver_role_utils';
import { cn } from '@apps/web/lib/utils';
import { type CaregiverRole } from '@libraries/typescript/api_client';

type RoleBadgeProps = {
    readonly role: CaregiverRole;
    readonly showFullName?: boolean;
    readonly className?: string;
};

/**
 * A badge component for displaying caregiver roles with consistent styling
 *
 * @param role - The caregiver role to display (e.g., "rn", "lpn", etc.)
 * @param showFullName - Whether to show the full name (e.g., "Registered Nurse") instead of abbreviation
 * @param className - Additional CSS classes to apply
 */
export function RoleBadge({
    role,
    showFullName = false,
    className,
}: RoleBadgeProps) {
    const roleColor = getRoleColor(role);
    const displayText = showFullName
        ? getRoleFullName(role)
        : getRoleDisplayName(role);
    const tooltipText = !showFullName ? getRoleFullName(role) : undefined;

    return (
        <Badge className={cn(roleColor, className)} title={tooltipText}>
            {displayText}
        </Badge>
    );
}
